export default __webpack_public_path__ + "static/media/notifications.1ad33646.svg";